import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { View, type ViewProps } from 'react-native'

import type { TChatMessageProps } from './ChatMessage.types'

type TChatMessageBubbleProps = Pick<TChatMessageProps, 'firstOfBatch' | 'isSender' | 'lastOfBatch'> & {
  className?: string
  children: ReactNode
} & ViewProps

export const ChatMessageBubble = ({
  className,
  firstOfBatch,
  isSender,
  lastOfBatch,
  ...props
}: TChatMessageBubbleProps) => (
  <View
    className={clsx(
      'lg:max-w-xl shadow-xs max-w-full',
      'rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-lg',
      isSender && 'self-end',
      {
        'rounded-tl-xs': !firstOfBatch && !isSender,
        'rounded-bl-xs': !lastOfBatch && !isSender,
        'rounded-tr-xs': !firstOfBatch && isSender,
        'rounded-br-xs': !lastOfBatch && isSender,
      },
      className,
    )}
    {...props}
  />
)
